// deps
import React from "react";

// styles
import { CartGroup } from "../styles";

export default function CartGroupContainer(props: {
    children: React.ReactNode;
    className?: string;
    withNoTitle?: boolean;
}): React.ReactElement {
    return (
        <CartGroup className={props.className} withNoTitle={props.withNoTitle}>
            {props.children}
        </CartGroup>
    );
}
